import router from './router'
import http from './http.js'
import { Message } from 'element-ui'

// const whiteList = ['/', '/login', '']
const whiteList = ['/nmlogin', '/nmzlqlogin', '/ablogin', '/yqerlogin', '/xnlogin', '/404', '/industry', '/source','/wmsLogin','wenlogin', '/bankScreenLogin']
    // let username = null
    // console.log(process.env.NODE_ENV,'测试');
    // if (process.env.NODE_ENV === "production") {
    //   username = 'dptest-admin'
    // } else {
    //   username = 'nx-dp'
    // }

router.beforeEach((to, from, next) => {
	console.log(to,from)
    if (window.localStorage.getItem('NMYDATAASSTSTOKEN') && whiteList.indexOf(to.path) < 0) {
        http({
            url: '/admin-service/getInfo',
            //请求方式
            method: 'get',
            //传递的参数
            data: {
                extsysCode: 100000010
            },

        }).then(res => {
            if (res.data.code === 200) {
                const user = res.data.user;
                window.localStorage.setItem('USERINFO', JSON.stringify(user))
                if (user.roles && user.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                    window.localStorage.setItem('SET_ROLES', user.roles)
                        // console.log(router.options.routes);
                    var pathItem = router.options.routes.find(item => {
                        return to.path == item.path
                    })
                    if (pathItem == undefined) {
                        next(`/404?redirect=${to.fullPath}`)

                    } else {
                        next()
                    }

                } else {
                    Message.error('没有访问权');
                }
            }
        })
    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            if (to.path == '/source') {
                http({
                    url: '/xmbapp-service/user/login',
                    //请求方式
                    method: 'post',
                    //传递的参数
                    data: {
                        username: 'dptest-admin',
                        password: '123456',
                        extsysCode: 100000010
                    },
                }).then(res => {
                    // this.flag = true
                    console.log(process.env.NODE_ENV);
                    const data = res.data;
                    if (res.data.code === 200) {
                        window.localStorage.setItem('NMYDATAAUSERNAME', 'dptest-admin')
                        window.localStorage.setItem('NMYDATAASSTSTOKEN', data.result.token)
                        window.localStorage.setItem('NMYDATAUSERINFO', JSON.stringify(data.result.sysUser))
                        next()

                    } else {
                        // this.$message.error(data);
                    }
                })
            } else {
                next()
            }
        } else {
            // if (window.localStorage.getItem('NMLOGIN') == '/nmzlqlogin') {
            //   next(`/nmzlqlogin?redirect=${to.fullPath}`) // 否则全部重定向到登录页
            // } if (window.localStorage.getItem('NMLOGIN') == '/nmlogin') {
            //   next(`/nmlogin?redirect=${to.fullPath}`) // 否则全部重定向到登录页
            // } 
            next(`/nmlogin?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        }
    }
})